/**
 * Persist "new invitation" badge seen state. Badge is cleared when meeting is
 * clicked into, started, or deleted.
 */
const NEW_INVITE_SEEN_KEY = 'rithmo_new_invite_seen'

export function getSeenNewInvitationIds() {
  try {
    const raw = window.localStorage.getItem(NEW_INVITE_SEEN_KEY)
    if (!raw) return new Set()
    const arr = JSON.parse(raw)
    return new Set(Array.isArray(arr) ? arr : [])
  } catch {
    return new Set()
  }
}

export function markInvitationSeen(meetingId) {
  if (!meetingId) return
  try {
    const seen = getSeenNewInvitationIds()
    seen.add(String(meetingId))
    window.localStorage.setItem(NEW_INVITE_SEEN_KEY, JSON.stringify([...seen]))
  } catch {
    // ignore
  }
}

/** Past-due meeting pulse: cleared when meeting is clicked, deleted, or obsolete (live/ended). */
const PAST_DUE_SEEN_KEY = 'rithmo_past_due_seen'

export function getPastDueSeenIds() {
  try {
    const raw = window.localStorage.getItem(PAST_DUE_SEEN_KEY)
    if (!raw) return new Set()
    const arr = JSON.parse(raw)
    return new Set(Array.isArray(arr) ? arr : [])
  } catch {
    return new Set()
  }
}

export function markPastDueSeen(meetingId) {
  if (!meetingId) return
  try {
    const seen = getPastDueSeenIds()
    seen.add(String(meetingId))
    window.localStorage.setItem(PAST_DUE_SEEN_KEY, JSON.stringify([...seen]))
  } catch {
    // ignore
  }
}
